import { render, staticRenderFns } from "./LaboratoryContinuousEvaluation.vue?vue&type=template&id=48e26122"
import script from "./LaboratoryContinuousEvaluation.vue?vue&type=script&lang=js"
export * from "./LaboratoryContinuousEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports